import { render, staticRenderFns } from "./JobShow.vue?vue&type=template&id=2f671ec2&"
import script from "./JobShow.vue?vue&type=script&lang=js&"
export * from "./JobShow.vue?vue&type=script&lang=js&"
import style0 from "./JobShow.vue?vue&type=style&index=0&id=2f671ec2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports